import { DataGrid } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import { cellRenderer, customHeader } from "./SARGrid";
import { formatDate, formatNumber } from "devextreme/localization";
import type { TranchRecommendedExercised } from "@/types/types";

type Props = { exercised: TranchRecommendedExercised[] | undefined };

export default function SarActualExercisedGrid({ exercised }: Props) {
  return (
    <div className="flex-1">
      <h2 className="pb-4 text-lg font-medium">Actual Exercised</h2>
      <DataGrid
        dataSource={exercised ?? []}
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        className="ao-grid"
        wordWrapEnabled={true}
        onCellPrepared={(e) => {
          if (e.rowType === "header") {
            e.cellElement.style.backgroundColor = "var(--primary-color)";
            e.cellElement.style.color = "white";
          }
        }}
      >
        <Column
          dataField="date"
          allowSorting={false}
          allowEditing={true}
          alignment={"center"}
          minWidth={100}
          headerCellRender={() => customHeader(``, "Date")}
          cellRender={(cellData) => {
            return cellData.data?.dateExercised
              ? cellRenderer(
                  cellData,
                  "date-of-grant",
                  formatDate(new Date(cellData?.data?.dateExercised), "MMM dd, yyyy")
                )
              : "";
          }}
        />
        <Column
          dataField="quantity"
          allowSorting={false}
          allowEditing={true}
          alignment={"center"}
          minWidth={100}
          headerCellRender={() => customHeader(``, "Quantity")}
          cellRender={(cellData) => {
            return cellData.data?.shares
              ? cellRenderer(
                  cellData,
                  "quantity",
                  formatNumber(cellData.data?.shares, "0#"),
                  "bg-[#fff]"
                )
              : "";
          }}
        />
        <Column
          dataField="price"
          allowSorting={false}
          allowEditing={true}
          alignment={"center"}
          minWidth={100}
          headerCellRender={() => customHeader(``, "Price")}
          cellRender={(cellData) => {
            return cellData.data?.price
              ? cellRenderer(
                  cellData,
                  "price",
                  formatNumber(cellData.data?.price, "$0#.##"),
                  "bg-[#fff]"
                )
              : "";
          }}
        />
      </DataGrid>
    </div>
  );
}
